import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import cView from './cView';

export default class c40v extends cView { // 機能情報

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stgs = { //  子で上書き
};

$cd_stss = { // 親を上書き
  sdld_c40rListsss: {c40r:[]},
  sdld_c40rDtlsss: {c40r:[]},
  sdld_c40rVsnListsss: {c40r:[]},
  s_c41m_vsn: -1,
  s_c40rc31s: '',
};

static op_loadList = (pd={
  elm: null,
}) => 
  (pd.elm == 'c40r') ?
    super.op_loadList({
      ...pd,
      b_vsn: false, // 履歴なし
      b_fnd: true, // 全利用会社共通
      ld_sortss: [
        { fld: 'c40rc11s', dtn: 'asc', mode: 'nmb' }
      ],
    })
  : super.op_loadList(pd)
;

static op_loadSlcList = (pd={
  elm: null,
}) => 
  (pd.elm == 'c40r') ?    
    super.op_loadSlcList({
      ...pd,
//      b_vsn: false, // 履歴なし
//      b_fnd: true, // 全利用会社共通
      b_vsn: false, // d_dats の key が null とならないために必要
      o_cnd: pd.o_cnd ?? (_dd_datss => {
//ff.l('c40v 59: {}'.f(global.t?.state.sgcd_stgs));
        let _cnd = cf.c(pd.elm, null, true, false);
//ff.l('58: {}'.f(_cnd))
        return _cnd;
      }),
      ld_sortss: [
        { fld: 'c40rc11s', dtn: 'asc', mode: 'nmb' }
      ],
    })
  : super.op_loadSlcList(pd);

$clp_loadLists = () => [ // 親を上書き
  cf.myRN_savePageStgs({
    sgc_pnlMode: 'dtl',
  }),
  c40v.op_loadList({
    elm: 'c40r',
  }),
];

$clp_loadDtls = () => [
  global.t?.op_loadList(),
];

$clp_upds = () => [
  cr.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_c40rListsss',
    b_vsn: false,
    dd_elmDefss: {
      c40r: {
        b_setPageKey: false,
        od_insDats: _dd_datss => {
          let _d = {
            c40rc11s: _dd_datss.c40r.d_flds.c40rc11s ?? '',
            c40rc31s: _dd_datss.c40r.d_flds.c40rc31s ?? '',
            c40ri11s: _dd_datss.c40r.d_flds.c40ri11s ?? '',
          };
          return _d;
        },
      },
    },
  }),
];

render() {
  return (
    ce.c(ce.RootDtl, {
      key: -1,
      d_hdrs: {
        d_lefts: {
          b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
        },
        d_edits: {
        },
      },
      d_bdys: {
        l_clds: [
          ce.c(ce.Pnl, {
            key: -1,
            mode: 'dtl',
            b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
            d_bdys: {
              l_clds: [
                ce.c(cr.InpTree, {
                  key: -1,
                  state: 'sdld_c40rListsss',
                  dd_elmDefss: {
                    c40r: {
                      pfx: 'モジュール',
                      b_row: true,
                      b_rootHdr: true,
                      b_ttl: false,
                      d_insFlds: cf.e('c40r').d_insFlds, 
                      d_btns: {
                        d_dlts: {
                          b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                        },
                      },
                      dd_fldDefss: cf.myRN_getFldDefs([
                        cf.f('c40rc11s', {
                        }),
                        cf.f('c40rc31s', {
                        }),
                        cf.f('c40ri11s', {
                        }),
                      ]),
                    },
                  },
                }),
              ],
            },
          }),

        ],
      }
    })
  );
}

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
